import dayjs from 'dayjs'
import type { Booking } from '../booking'
import type { RelatedStore } from '../related-store'

// 予約のキャンセル / 変更可否を判定する純関数。
// 元は composables/booking.ts 内に閉じていたが、店舗の booking-policy 時間境界の
// 計算は wire payload 同様に回帰検知したい振る舞いなので外出しした。
//
// 判定基準: 「現在時刻 + ポリシー時間」が予約時刻と同じ or 予約時刻より前 (まだ余裕がある) なら可。
// 言い換えると「予約時刻まで policy-hours 以上残っているか」。

const isWithinPolicy = (
  bookingFromAt: string | Date,
  policyHours: number,
  now: dayjs.Dayjs = dayjs()
): boolean => {
  const bookingDate = dayjs(bookingFromAt)
  const policyDeadline = now.add(policyHours, 'hour')
  return bookingDate.isSame(policyDeadline) || bookingDate.isAfter(policyDeadline)
}

export const cancelable = (
  booking: Pick<Booking, 'fromAt'>,
  store: RelatedStore,
  now: dayjs.Dayjs = dayjs()
): boolean => {
  const bookingIsEnabled = store.bookingSettings.isEnabled
  const cancelablePolicyHours = store.bookingSettings.customerSettings?.cancelablePolicyHours
  if (!bookingIsEnabled || cancelablePolicyHours === undefined) return false
  return isWithinPolicy(booking.fromAt, cancelablePolicyHours, now)
}

export const updatable = (
  booking: Pick<Booking, 'fromAt'>,
  store: RelatedStore,
  now: dayjs.Dayjs = dayjs()
): boolean => {
  const bookingIsEnabled = store.bookingSettings.isEnabled
  const updatablePolicyHours = store.bookingSettings.customerSettings?.updatablePolicyHours
  if (!bookingIsEnabled || updatablePolicyHours === undefined) return false
  return isWithinPolicy(booking.fromAt, updatablePolicyHours, now)
}
